<template>
  <div class="p-postEditor__itemWrapper">
    <div v-if="editingItemIndex !== index" @click="editItem">
      <ButtonItemPreview :item="item" />
    </div>
    <item-form v-else-if="editingItemIndex === index" :item="item">
      <v-row class="ma-0" style="display: block;" v-if="templateFlag">
        <ButtonTemplate :is-editing="isEditing" @set-template="setTemplateData" @close-template="closeTemplate"/>
      </v-row>
      <v-row class="ma-0" v-else>
        <v-col lg="6" class="px-0 py-3">
            <v-banner class="pa-0" shaped :sticky="true" style="top: 20px">
              <ButtonItemFormPreview :itemableAttributes="editingItemable" @open-template="openTemplate"/>
            </v-banner>
          </v-col>
          <v-col lg="6" class="py-3">
            <BaseForm :item="item" :index="index"/>
            <DetailForm :item="item" :index="index" />
          </v-col>
      </v-row>
    </item-form>
  </div>
</template>

<script>
import itemUtilsMixin from '@/mixins/item_utils'
import InputLabel from '@/components/commons/formParts/inputLabel'
import formValidationUtils from '@/mixins/form_validation_utils'
import ButtonItemPreview from '../previews/ButtonItemPreview'
import ButtonItemFormPreview from './ButtonItemFormPreview'
import BaseForm from './BaseForm'
import DetailForm from './DetailForm'
import ButtonTemplate from './ButtonTemplate'

export default {
  name: 'ButtonItem',
  components: {
    DetailForm,
    BaseForm,
    ButtonItemFormPreview,
    ButtonItemPreview,
    InputLabel,
    ButtonTemplate
  },
  data () {
    return {
      templateFlag: true,
      isEditing: false
    }
  },
  mounted () {
    this.templateFlag = !this.item.itemableAttributes.sizeType
  },
  mixins: [itemUtilsMixin, formValidationUtils],
  methods: {
    setTemplateData (template) {
      this.templateFlag = false
      this.updateEditingItemable(template.sizeType, 'sizeType')
      this.updateEditingItemable(template.fontSize, 'fontSize')
      this.updateEditingItemable(template.backgroundColor, 'backgroundColor')
      this.updateEditingItemable(template.content, 'content')
      this.updateEditingItemable(template.radius, 'radius')
      this.updateEditingItemable(template.padding, 'padding')
      this.updateEditingItemable(template.beforeIcon, 'beforeIcon')
      this.updateEditingItemable(template.afterIcon, 'afterIcon')
      this.updateEditingItemable(template.gradientColor, 'gradientColor')
      this.updateEditingItemable(template.boxShadow, 'boxShadow')
      this.updateEditingItemable(template.labelText, 'labelText')
      this.updateEditingItemable(template.labelType, 'labelType')
      if (template.border) {
        this.updateEditingItemable(template.border.top, 'border', 'top')
        this.updateEditingItemable(template.border.bottom, 'border', 'bottom')
        this.updateEditingItemable(template.border.left, 'border', 'left')
        this.updateEditingItemable(template.border.right, 'border', 'right')
      }
    },
    closeTemplate () {
      this.templateFlag = false
    },
    openTemplate () {
      this.isEditing = true
      this.templateFlag = true
    }
  }
}
</script>
